import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect, useState } from 'react';
import ErrorBoundary from '@sbt-web/error-boundary';
import { searchRecommendedDetail } from '@sbt-web/network/client';
import { AdItem } from '@sbt-web/network/types';
import { AdDetailCarousel } from '@/client/components/Detail/AdDetailCarousel';
import { trackCardClick, trackCardImpression, trackCarouselImpression } from './tracking';
export type Props = {
  item: AdItem;
  className?: string;
  onActualRender?: () => void;
};
const RecommendedCarousel = t0 => {
  const $ = _c(14);
  const {
    item,
    className,
    onActualRender
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [data, setData] = useState(t1);
  const [isLoading, setIsLoading] = useState(true);
  let t2;
  let t3;
  if ($[1] !== item.urn) {
    t2 = () => {
      searchRecommendedDetail(process.env.NEXT_PUBLIC_HADES_BASE_URL, item.urn).then(t4 => {
        const {
          body
        } = t4;
        setData(body.ads);
      }).finally(() => {
        setIsLoading(false);
      });
    };
    t3 = [item.urn];
    $[1] = item.urn;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  useEffect(t2, t3);
  let t4;
  if ($[4] !== data || $[5] !== item || $[6] !== onActualRender) {
    t4 = () => {
      onActualRender?.();
      trackCarouselImpression(item, data);
    };
    $[4] = data;
    $[5] = item;
    $[6] = onActualRender;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const onVisible = t4;
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      right: "Altri annunci in evidenza",
      left: "Annunci in evidenza precedenti"
    };
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== className || $[10] !== data || $[11] !== isLoading || $[12] !== onVisible) {
    t6 = <AdDetailCarousel title="In evidenza per te" navigationLabels={t5} data={data} className={className} onVisible={onVisible} onCardImpression={trackCardImpression} onClick={trackCardClick} isLoading={isLoading} />;
    $[9] = className;
    $[10] = data;
    $[11] = isLoading;
    $[12] = onVisible;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
};
const RecommendedAds = props => {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <ErrorBoundary><RecommendedCarousel {...props} /></ErrorBoundary>;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
export { RecommendedAds };